var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgValuePropLowRates = function SvgValuePropLowRates(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_2951)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.623 0.695801L11.624 5.6958V1.6958H4.624V12.6958L0.625 16.6948L2.079 18.1498L4.624 15.6038V32.6948H28.623H28.624V15.6038L31.17 18.1498L32.624 16.6948L28.124 12.1948L26.625 13.6958L26.624 30.6958H21.623L21.624 17.6958H21.619V17.6948H11.625L11.624 30.6958H6.623L6.624 13.6048L16.625 3.6038L19.006 5.9848L20.46 4.5318L16.625 0.696801L16.624 0.695801H16.623ZM6.625 3.6958H9.626L9.625 7.6948L6.624 10.6968L6.625 3.6958ZM13.624 19.6958H19.625L19.624 30.6958H13.623L13.624 19.6958Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1717 8.74531L22.6597 6.23231L17.3867 11.5453V7.95831H15.3867V14.9593H22.3867V12.9593H18.8007L22.5937 9.16531L25.1037 11.6753L32.6247 4.09831L31.2217 2.69531L25.1717 8.74531Z",
    fill: "#0157FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_2951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.625 0.695312)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgValuePropLowRates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/value_prop_low_rates.f59e0066fa0c0e51ee9bfb5ba3af3202.svg";